import { render, staticRenderFns } from "./putOnShelvesLabel.vue?vue&type=template&id=17515e13&scoped=true&"
import script from "./putOnShelvesLabel.vue?vue&type=script&lang=js&"
export * from "./putOnShelvesLabel.vue?vue&type=script&lang=js&"
import style0 from "./putOnShelvesLabel.vue?vue&type=style&index=0&id=17515e13&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17515e13",
  null
  
)

export default component.exports